import { Tooltip, ITooltip } from 'react-tooltip'

interface TwinToolTipProps extends ITooltip {}

const TwinToolTip: React.FC<TwinToolTipProps> = ({className, ...rest}) => {
    return (<Tooltip className={'z-10 ' + className} {...rest} />)
}
export const TwinToolTipWhite: React.FC<TwinToolTipProps> = ({className, ...rest}) => {
    return (<Tooltip className={'z-10 tooltip_white ' + className} {...rest} />)
}

export default TwinToolTip